import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { themeColors } from '../../../constants/themes';
import { Circle } from '../FlexStyle';

export const ImageSection = styled('div')`
  width: 387px;
  display: flex;
  flex-direction: column;
  padding-left: 86px;
  background-color: ${themeColors.backgroundLightBlue};
  position: relative;
  padding-top: 17px;
  overflow: hidden
`;

export const MainImage = styled('img')`
  height: ${({height})=> height||'300px'};
  width: 282px;
  z-index: 10;
  padding: 10px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0px 1px 7px 0 #0069fa26;
  margin-bottom: 15px;
  object-fit: contain;
`;

export const SmallImagesContainer = styled('div')`
  width: 282px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-start;
  z-index: 10;
`;

export const SmallImage = styled('img')`
  margin: 0 15px 15px 0;
  &:nth-of-type(3n){
    margin-right: 0;
  }
  height: 79px;
  width: 84px;
  padding: 10px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0px 1px 7px 0 #0069fa26;
  object-fit: contain;
`;


const ItemImage = ({ mainImage = '', pictures = [] }) => (
  <ImageSection>
    <Circle
      style={{
        position: 'absolute',
        top: '-5px',
        left: '-231px',
        minWidth: '356px',
        height: '356px',
      }}
    />
    <MainImage src={mainImage} />
    <SmallImagesContainer>
      {pictures.length > 0 ? (
        pictures.map(({ id, url }) => (
          <SmallImage key={`single-small-${id}`} src={url} />
        ))
      ) : (
        <SmallImage src={mainImage} />
      )}
    </SmallImagesContainer>
  </ImageSection>
);

ItemImage.propTypes = {
  mainImage: PropTypes.string.isRequired,
  pictures: PropTypes.arrayOf(PropTypes.object),
};

export default ItemImage;
